import { ValidationSchema } from './Context'

export const initialValues: ValidationSchema = {
  firstName: {
    value: '',
    error: '',
    required: true,
    validate: 'text',
    maxLength: 25,
    helperText: 'Custom error message'
  },
  lastName: {
    value: '',
    error: '',
    maxLength: 20
  },
  branchID: {
    value: '',
    error: '',
    minLength: 6,
    maxLength: 10,
  },
  userName: {
    value: '',
    error: '',
    required: true,
    validate: 'text',
    minLength: 4,
    maxLength: 20,
    helperText: 'Custom error message'
  },
  bank: {
    value: '',
    error: '',
    validate: 'text'
  },
  email: {
    value: '',
    error: '',
    validate: 'email'
  },
  account: {
    value: '',
    error: '',
    validate: 'text',
  },
  holder: {
    value: '',
    error: '',
    validate: 'text',
  },
  code: {
    value: '',
    error: '',
    validate: 'text',
  },
  detail: {
    value: '',
    error: '',
    validate: 'text',
  },
  gender: {
    value: '',
    error: '',
    validate: 'select'
  },
  date: {
    value: '',
    error: ''
  },
  idNo: {
    value: '',
    error: ''
  },
  branch: {
    value: '',
    error: ''
  },
  expiry: {
    value: '',
    error: ''
  },

  accountname: {
    value: '',
    error: '',
    validate: 'text',
    minLength: 3,
    maxLength: 20
  },

  city: {
    value: '',
    error: '',
    validate: 'text',
    minLength: 3,
    maxLength: 20
  },
  Password: {
    value: '',
    error: '',
    validate: 'Password',
    minLength: 6,
    required: true,
    maxLength: 20,
    helperText: 'Custom error message'
  },

  phone: {
    value: '',
    error: '',
    validate: 'phone',
    maxLength: 15,
    required: true,
    // helperText: 'Invalid phone number'
  }
}
